import React from "react";
import { makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    numbersDisplay: {
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        flexWrap: "wrap",
        margin: "20px 0",
        "@media (max-width: 768px)": {
            margin: "12px 0",
            gap: "8px",
        },
    },
    numberBubble: {
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "24px",
        fontWeight: "bold",
        transition: "background-color 0.3s ease",
        "@media (max-width: 768px)": {
            width: "45px",
            height: "45px",
            fontSize: "20px",
        },
    },
    numberBubbleSuccess: {
        backgroundColor: tokens.colorPaletteGreenBackground3,
    },
});

interface NumbersDisplayProps {
    numbers: number[];
    highlightedIndices?: Set<number>;
}

export function NumbersDisplay({
    numbers,
    highlightedIndices,
}: NumbersDisplayProps) {
    const styles = useStyles();

    return (
        <div>
            <div className={styles.numbersDisplay}>
                {numbers.map((num, index) => (
                    <div
                        key={index}
                        className={`${styles.numberBubble} ${
                            highlightedIndices?.has(index)
                                ? styles.numberBubbleSuccess
                                : ""
                        }`}
                    >
                        {num}
                    </div>
                ))}
            </div>
        </div>
    );
}
